<template>
  <div id="app">
    <MetronomeTimer />
  </div>
</template>

<script>
import MetronomeTimer from './components/Timer.vue'

export default {
  name: 'App',
  components: {
    MetronomeTimer
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
